import { useQuery } from "react-query";
import { TargetGroups } from "../../types/types";
import { api } from "../api";
import { types } from "../../constants";

interface GetUnitGroupsRes {
	data: TargetGroups[];
}

export const getDriverGroups = (): Promise<GetUnitGroupsRes> => {
	return api.get(`wialon/drivergroups`);
};

export const useDriverGroups = (options?: { then?: (x: GetUnitGroupsRes) => any }) => {
	const cacheKey: (string | Record<string, number | string | Date>)[] = [types.DRIVER_GROUPS, types.ALL];
	const query = useQuery(
		cacheKey,
		() =>
			getDriverGroups().then((unit) => {
				options && options.then && options.then(unit);
				return unit;
			}),
		{ staleTime: 1000 * 5 }
	);
	return query;
};
